<div class="title-main-container">
    <div class="title-main-content small-wrapper">
        <div class="title-main-content-header">
            {{ title }}
        </div>
        <div class="title-main-content-subtitle" *ngIf="subtitle">
            {{ subtitle }}
        </div>
    </div>
</div>
